import { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { setMessage, toggleUpserting } from 'state/reducers/convert.reducers';
//constants
import { intialMessage, pagesEnum } from 'constants/ui.constants';
import { getBalancesByCompanyId } from 'services/balance.services';
import { User } from 'constants/user.constants';
import { getUserDetails } from 'state/reducers/user.reducers';
import { getBalancesActivityByCompanyId } from 'services/activity.services';

export default function ConvertApp() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user: User = useAppSelector(getUserDetails);
  useEffect(() => {
    dispatch(toggleUpserting(true));
    dispatch(setMessage(intialMessage));
    dispatch(getBalancesByCompanyId());
    dispatch(getBalancesActivityByCompanyId(Number(user?.companyId)));
    navigate(`/${pagesEnum.CONVERT}/new`);
  }, []);
  return <Fragment></Fragment>;
}
